export function JStreeTypeIconPage() {
    return {
        'page-normal': {
            icon: `icon-visibility ${wex.iconvisibility.page.parent.normal}`,
        },
        'page-normal-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.parent.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'page-member': {
            icon: `icon-visibility ${wex.iconvisibility.page.parent.member}`,
        },
        'page-member-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.parent.member}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'page-specific': {
            icon: `icon-visibility ${wex.iconvisibility.page.parent.specific}`,
        },
        'page-specific-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.parent.specific}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'internal-normal': {
            icon: `icon-visibility ${wex.iconvisibility.page.internal.normal}`,
        },
        'internal-normal-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.internal.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'internal-member': {
            icon: `icon-visibility ${wex.iconvisibility.page.internal.member}`,
        },
        'internal-member-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.internal.member}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'internal-specific': {
            icon: `icon-visibility ${wex.iconvisibility.page.internal.specific}`,
        },
        'internal-specific-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.internal.specific}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'child-normal': {
            icon: `icon-visibility ${wex.iconvisibility.page.child.normal}`,
        },
        'child-normal-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.child.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'child-member': {
            icon: `icon-visibility ${wex.iconvisibility.page.child.member}`,
        },
        'child-member-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.child.member}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'child-specific': {
            icon: `icon-visibility ${wex.iconvisibility.page.child.specific}`,
        },
        'child-specific-hide': {
            icon: `icon-visibility ${wex.iconvisibility.page.child.specific}`,
            a_attr: { style: 'opacity: 0.5' },
        },
    };
}

export function JStreeTypeIconBlog() {
    return {
        'category-normal': {
            icon: `icon-visibility ${wex.iconvisibility.blog.category.normal}`,
        },
        'category-normal-hide': {
            icon: `icon-visibility ${wex.iconvisibility.blog.category.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'category-member': {
            icon: `icon-visibility ${wex.iconvisibility.blog.category.member}`,
        },
        'category-member-hide': {
            icon: `icon-visibility ${wex.iconvisibility.blog.category.member}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'category-specific': {
            icon: `icon-visibility ${wex.iconvisibility.blog.category.specific}`,
        },
        'category-specific-hide': {
            icon: `icon-visibility ${wex.iconvisibility.blog.category.specific}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'post-normal': {
            icon: `icon-visibility ${wex.iconvisibility.blog.post.normal}`,
        },
        'post-normal-hide': {
            icon: `icon-visibility ${wex.iconvisibility.blog.post.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'post-member': {
            icon: `icon-visibility ${wex.iconvisibility.blog.post.member}`,
        },
        'post-member-hide': {
            icon: `icon-visibility ${wex.iconvisibility.blog.post.member}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'post-specific': {
            icon: `icon-visibility ${wex.iconvisibility.blog.post.specific}`,
        },
        'post-specific-hide': {
            icon: `icon-visibility ${wex.iconvisibility.blog.post.specific}`,
            a_attr: { style: 'opacity: 0.5' },
        },
    };
}

export function JStreeTypeIconSystem() {
    return {
        'system-normal': {
            icon: `icon-visibility ${wex.iconvisibility.system.normal}`,
        },
        'system-normal-hide': {
            icon: `icon-visibility ${wex.iconvisibility.system.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'system-member': {
            icon: `icon-visibility ${wex.iconvisibility.system.member}`,
        },
        'system-member-hide': {
            icon: `icon-visibility ${wex.iconvisibility.system.member}`,
            a_attr: { style: 'opacity: 0.5' },
        },
        'system-specific': {
            icon: `icon-visibility ${wex.iconvisibility.system.specific}`,
        },
        'system-specific-hide': {
            icon: `icon-visibility ${wex.iconvisibility.system.specific}`,
            a_attr: { style: 'opacity: 0.5' },
        },
    };
}

export function JStreeTypeIconHome() {
    return {
        'home-normal': {
            icon: `icon-visibility ${wex.iconvisibility.home.normal}`,
            a_attr: {
                style: 'font-weight:bold',
            },
        },
        'home-member': {
            icon: `icon-visibility ${wex.iconvisibility.home.member}`,
            a_attr: {
                style: 'font-weight:bold',
            },
        },
        'home-specific': {
            icon: `icon-visibility ${wex.iconvisibility.home.specific}`,
            a_attr: {
                style: 'font-weight:bold',
            },
        },
    };
}

export function JStreeTypeIconMenu() {
    return {
        'menu-none': {
            icon: `icon-visibility ${wex.iconvisibility.menu.normal}`,
            a_attr: { style: 'opacity: 0.5' },
        },
    };
}
